import {ID, Response} from '../../../../../../../_metronic/helpers'
export type User = {
  id?: ID
  name?: string
  avatar?: string
  email?: string
  username?: string
  firstname?: string
  lastname?: string
  position?: string
  role?: string
  last_login?: string
  two_steps?: boolean
  joined_day?: string
  online?: boolean
  initials?: {
    label: string
    state: string
  }
}

export type UsersQueryResponse = Response<Array<User>>

export const initialUser: User = {
  avatar: 'avatars/300-6.jpg',
  position: 'Art Director',
  role: 'Administrator',
  name: '',
  email: '',
}

export interface IUsers {
  id?: ID
  uuid?: string
  username?: string
  firstname?: string
  lastname?: string
  email?: string
  password?: string
  confirm_password?: string
  device_name?: string
}

export const UsersInitValues: IUsers = {
  username: '',
  firstname: '',
  lastname: '',
  email: '',
  password: '',
  confirm_password: '',
  device_name: '',
}
export interface Properties {
  code?: string
  id?: number
  uuid?: string
  name?: string
  regularized?: boolean
  measurement_unit?: {
    abbreviation?: string
  }
  identifier?: string
  project_id?: number
  role?: string

  initials?: {
    label: string
    state: string
  }
  address?: {
    zip_code?: string
    city?: string
    state?: string
    street_name?: string
    district?: string
    complement?: string
    number?: number
  }

  project?: {
    id: number
    code: string
    description: string
  }
  fields?: [
    {
      name: string
      id: number
    }
  ]
  enterprises?: [
    {
      id: number
      name: string
    }
  ]
}
export interface PropertyParticipations {
  code?: string
  id?: number
  uuid?: string
  name?: string
  regularized?: boolean
  measurement_unit?: {
    abbreviation?: string
  }
  identifier?: string

  role?: string

  initials?: {
    label: string
    state: string
  }

  address?: {
    zip_code?: string
    street_name?: string
    district?: string
    complement?: string
    city?: string
    state?: string
    number?: number
  }

  project?: {
    id: number
    code: string
    description: string
  }
  fields?: [
    {
      name: string
      id: number
    }
  ]
  enterprises?: [
    {
      id: number
      name: string
    }
  ]
}

export type PropertiesQueryResponse = Response<Array<Properties>>

export const propertyInitValues: Properties = {}
